module.exports = __webpack_public_path__ + "img/deskshelf23.ba3619d6.jpg";